var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home relative z-10"},[_vm._m(0),_c('div',{staticClass:"bg-grey-lightest rounded-medium px-5 py-5 md:px-10 2xl:px-40 md:py-10 2xl:py-20"},[_c('AnimalType'),_c('Navigation',_vm._b({on:{"click":function($event){return _vm.onNavigationClick($event, '', _vm.nextRoute)}}},'Navigation',{
        prev: {disabled: true},
        next: {disabled: _vm.isNextDisabled, isHidden: false},
      },false))],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"container-header"},[_c('h1',{staticClass:"title"},[_vm._v(" Select the animal type ")])])
}]

export { render, staticRenderFns }